"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m17.1991 20-5.1987-2.2909V4l2.8593 4.9091 5.5524 1.2024-3.7853 4.2363L17.1991 20z",
    fill: "rgb(var(--colour-neutral-3, 223, 223, 223))"
  }), _react.default.createElement("path", {
    d: "m6.8009 20 5.1987-2.2909V4L9.1403 8.9091l-5.5524 1.2024 3.7853 4.2363L6.8008 20z"
  })];
};
exports.default = _default;